import React, { Component } from 'react';

//Core Libs
import prd from "../../Core/Products";

// Componets
import ProductNode 		from '../../Reducer/ProductNode';
import BuildFor 		from '../../Reducer/Filters/BuildFor';
import OnSale 			from '../../Reducer/Filters/OnSale';
import Categories 		from '../../Reducer/Filters/Categories';

import DocumentMeta from 'react-document-meta';

class ProductListing extends React.Component {

	constructor(props) {
	
		super(props);

		this.state = {
			loading: true,
			products: {},
			productType: window.location.pathname.includes('cycles') ? 'CYCLE' : 'ACCESSORY',
			buildFor: '',
			onSale: '',
			catID: ''
		}
		
	}
	
	componentWillMount(){	
		this.callAPI();
	}

	callAPI = () => {
		
		let data = {
			productType: 	this.state.productType,
			buildFor: 		this.state.buildFor,
			onSale: 		this.state.onSale,
			catID: 			this.state.catID,

		};

		this.setState({
			loading: true,
		});			

		prd.getAllProducts( data, (response) => {

			this.setState({
				products: response.data,
				loading: false,
			});
			
		});

    }


    setFilters = (data) => {
    	
		let attr = [ Object.keys( data )[0] ][0];
		
		this.setState({
			[ Object.keys( data )[0] ]: data[ attr ]
		}, () => this.callAPI() );
		
	}


		
	render() {

		let products = '';

		if( this.state.loading == false ) {
			products = (
				<div className="row">
					{ 
						this.state.products.length > 0 
							? (
								this.state.products.map(function(item, i){
									return(
										<div className="col-xs-12 col-sm-6 col-md-4" key={i}>
											<ProductNode item={item} />
										</div>					
									)
								})
							) : (

								<div className="col-sm-12"> 
									<p className="product-not-found">Kan du ikke finde det ønskede produkt</p>
								</div>
							)
					}
				</div>
			)

        } else {
			products = <div className="loading-container"></div>
        }

        const meta = {
            title:          'Køb cykel og tilbehør fra alaska cykler København. Vi sælger verdensklasse cykler og tilbehør i københavn til meget billig pris',
            description:    'Hos Alaska cykler åbner vi dørene for en ny verden af ​​cykelkultur. We are a land of the world where there are most cyclists, therefore',
            meta: {
                charset:    'utf-8',
                name: {
                    keywords: 'cykel online københavn, køb cykel københavn, cykel tilbehør københavn, shimano nexus gear cykel københavn'
                }
            }
        };

		return (
			<div className="listing-page">
            
                <DocumentMeta {...meta} />

                <div className="container product-container">
                	<div className="row">
                		<div className="col-sm-12">
                			<ul className="filters">
                				
                				<li>
                					{
                						this.state.productType === 'CYCLE' 
                							? <BuildFor setFilters={ this.setFilters } />
                							: <Categories setFilters={ this.setFilters } />
                					}
                				</li>

                				<li> 
                					<OnSale setFilters={ this.setFilters } />
                				</li>
                			</ul>
                		</div>
                	</div>

                	{products}

                </div>
			</div>
		);
	}
}

export default ProductListing;



// WEBPACK FOOTER //
// ./src/Pages/Products/Listings.js